module.exports = __webpack_public_path__ + "media/images/card_logos/jcb-logo-6c2a6473d5e12c79691a052373064a37.png";